import React from "react";
import { PAGE_SIZE_OPTIONS } from "./useTableView";

type Props = {
  value: number;
  onChange: (size: number) => void;
  className?: string;
};

/**
 * The "Show N entries" control that sits above each list. Previously this markup
 * was copy-pasted per screen with no handler wired up, so changing it did nothing.
 */
const PageSizeSelect = ({ value, onChange, className = "" }: Props) => {
  const id = React.useId();

  return (
    <div
      className={`flex items-center gap-2 text-sm text-slate-500 ${className}`}
    >
      <label htmlFor={id}>Show</label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="rounded-md border border-slate-300 bg-white px-2 py-1 text-sm focus:outline-none focus:border-vg-blue focus:ring-[3px] focus:ring-vg-blue/15 transition-colors"
      >
        {PAGE_SIZE_OPTIONS.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
      <span>entries</span>
    </div>
  );
};

export default PageSizeSelect;
